import styled from '@emotion/styled'
export const StyleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const StyleTabsBgWrapper = styled.div<any>`
  margin-bottom: 20px;
  display: flex;
  overflow: hidden;
`
export const StyleTabsItems = styled.div<any>`
  display: flex;
  column-gap: 10px;
  align-items: center;
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  overflow-x: auto;
  padding: 7px 10px;
  -ms-overflow-style: none;
  display: flex;
  scrollbar-width: none;
  overflow: auth;
  ::-webkit-scrollbar {
    display: none;
  }
  ${(props: any) => props.styleWrapper}
`
export const StyleTabItem = styled.div<any>`
  font-size: 12px;
  color: ${(props: any) =>
    !!props.isActive ? props.theme.colors.white : props.theme.colors.text};
  background: ${(props: any) =>
    !!props.isActive ? props.theme.colors.secondary : 'transparent'};
  border-radius: 8px;
  padding: 10px 15px;
  border: 0px;
  transition: 0.5s ease;
  white-space: nowrap;
  &:hover {
    background: ${(props: any) => props.theme.colors.secondary};
    color: ${(props: any) => props.theme.colors.white};
  }
`
